export enum ClinicInvoiceBillingType {
  ONE_TIME = 'one_time',
  MONTHLY = 'monthly',
  MONTHLY_ADD_ON = 'monthly_add_on',
  INITIAL_MONTH = 'initial_month',
}
